import { useState } from 'react'
import { message } from 'antd'
import {
  CensusCsvRowDownloadType,
  downloadCMv2RowReport,
} from '../api/census-enrollment-platform-api-client'
import { downloadFile } from 'helpers/download-file'

export const useDownloadCMv2RowReport = () => {
  const [loading, setLoading] = useState(false)

  const downloadReport = async (
    publicKey: string,
    rowType: CensusCsvRowDownloadType | 'ACTIVITY'
  ) => {
    setLoading(true)
    try {
      const { blob, fileName } = await downloadCMv2RowReport(publicKey, rowType)

      downloadFile(blob, fileName)

      message.success('Report downloaded successfully')
    } catch (error) {
      console.error('Download failed:', error)
      message.error('Failed to download report')
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    downloadReport,
  }
}
